import i18n from 'i18next'
import { FOUND_STOCK } from '../../navigation/constants'

// Producer and consumer of the Sobrantes deep link live together: every page that links INTO this
// screen (cycle counts, inventory history) builds the query string here, and the screen itself
// parses it here, so the two can never drift apart.

// The count-resolve skip vocabulary (FoundStock::CountResolutionCreator). Lowercase by contract,
// except FOUND_STOCK_NOT_AUTHORIZED, which the creator emits as an upper-case ExpectedError code;
// any other upper-case code is shown raw.
export const SKIP_REASONS = [
  'stale',
  'transient_units_present',
  'lot_ambiguous',
  'lot_unknown',
  'unit_code_product',
  'product_missing',
  'product_not_in_count',
  'duplicate_row',
  'surplus_exceeds_cap',
  'resolve_cap_exceeded',
  'found_stock_disabled',
  'error',
  'FOUND_STOCK_NOT_AUTHORIZED',
]

export const foundStockDeepLink = (warehouseId, { location_code, declaration_id, cycle_count_id } = {}) => {
  const qs = new URLSearchParams()
  if (location_code) qs.set('location_code', location_code)
  if (declaration_id != null) qs.set('declaration_id', String(declaration_id))
  if (cycle_count_id != null) qs.set('cycle_count_id', String(cycle_count_id))
  const query = qs.toString()
  return FOUND_STOCK.replace(':warehouse_id', encodeURIComponent(String(warehouseId))) + (query ? `?${query}` : '')
}

// Deep-link contract (spec §2.2): location_code / declaration_id become server filters and
// declaration_id also opens that declaration's drawer (a settled one has left the queue);
// cycle_count_id is a client-side highlight only. Parsed once per mount.
export const parseDeepLink = (search, pageSize) => {
  const qs = new URLSearchParams(search || '')
  const params = { page: 1, per_page: Number(pageSize) || 25 }
  if (qs.get('location_code')) params.location_code = qs.get('location_code')
  if (qs.get('declaration_id')) params.declaration_id = qs.get('declaration_id')
  const cycleCountId = Number(qs.get('cycle_count_id'))
  const declarationId = Number(qs.get('declaration_id'))
  return {
    params,
    highlightCycleCountId: Number.isInteger(cycleCountId) && cycleCountId > 0 ? cycleCountId : null,
    openDeclarationId: Number.isInteger(declarationId) && declarationId > 0 ? declarationId : null,
  }
}

export const summarizeResolveFoundStock = result => {
  const fs = result?.found_stock
  if (!fs) return null
  return {
    unitsCreated: fs.units_created ?? 0,
    rowsSkipped: fs.rows_skipped ?? 0,
    reasons: Object.entries(fs.skipped_by_reason || {}).map(([key, count]) => ({ key, count })),
  }
}

export const reasonLabel = key => (SKIP_REASONS.includes(key) ? i18n.t(`cycle_counts.found_stock.reasons.${key}`) : key)
